<label
  id="boels-searchbox"
  class="boels-custom-search-box__label"
  [ngClass]="{
    '-remove-bottom-radius': hasResults(),
    '-homepage': isHomepage(),
    '-header': !isHomepage(),
  }"
>
  <input
    #searchInput
    class="boels-custom-search-box__input"
    [placeholder]="
      (isHomepage()
        ? 'homepageSearch.placeholder.productSearch'
        : 'header.searchBox.placeholder'
      ) | transloco
    "
    [(ngModel)]="searchQueryValue"
    (input)="updateSearchBoxValue(searchInput.value)"
    (focusout)="onFocusOut()"
    (focus)="
      showResultsPreview.set(
        !!searchQueryValue() && searchQueryValue().length > 0
      );
      navigatedToSearchResults.set(false);
      onFocusSearchInput()
    "
    aria-autocomplete="list"
    aria-controls="results-list"
    role="combobox"
    type="text"
    (keydown)="onKeyDown($event, searchQueryValue())"
    [attr.aria-expanded]="suggestions().length > 0"
    [attr.id]="isHomepage() ? 'search-box-homepage' : 'search-box'"
    [enterKeyHint]="'search'"
  />

  @if (searchQueryValue()) {
    <fa-icon
      [icon]="faCircleXmark"
      size="sm"
      (mousedown)="clearSearchBoxValue()"
      (keydown.enter)="clearSearchBoxValue()"
      class="boels-custom-search-box__icon -clear-search"
      tabindex="0"
    ></fa-icon>
  }
  @if (!isHomepage()) {
    @if (isMobile()) {
      <button
        class="boels-custom-search-box__search-button mobile-view-only"
        (click)="onNavigateToSearchResults(searchQueryValue())"
      >
        <fa-icon
          [icon]="faSearch"
          size="xs"
          class="boels-custom-search-box__icon -search"
          tabindex="-1"
        ></fa-icon>
      </button>
    } @else {
      <button
        boelsButton
        [size]="'sm'"
        [icon]="faSearch"
        [variant]="'primary-black'"
        class="boels-custom-search-box__search-button desktop-view-only"
        (click)="onNavigateToSearchResults(searchQueryValue())"
      >
        {{ 'header.searchBox.search' | transloco }}
      </button>
    }
  }
</label>
@if (shouldShowResultsPreview()) {
  <div
    class="boels-custom-search-box__results"
    role="listbox"
    id="results-list"
    boelsQa="search-results"
  >
    @if (suggestions().length > 0) {
      @for (suggestion of suggestions(); track suggestion; let index = $index) {
        <a
          (click)="onNavigateToSearchResults(suggestion.value)"
          boelsMousedown
          [id]="'suggestion-' + index"
          class="boels-custom-search-box__result -suggestion"
          role="option"
          tabindex="-1"
          [ngClass]="{ active: index === activeSearchResultIndex() }"
          [attr.aria-selected]="index === activeSearchResultIndex()"
          boelsQa="search-result-suggestion"
        >
          <span class="highlight">{{
            suggestion?.value?.substring(0, searchQueryValue().length)
          }}</span>
          <span>{{
            suggestion?.value?.substring(searchQueryValue().length)
          }}</span>
        </a>
      }
    }
    @if (products().length > 0) {
      @for (product of products(); track product; let index = $index) {
        <a
          (click)="setInputValue(product)"
          boelsMousedown
          [id]="'suggestion-' + (index + suggestions().length)"
          class="boels-custom-search-box__result -product"
          role="option"
          tabindex="-1"
          [attr.aria-selected]="
            index + suggestions().length === activeSearchResultIndex()
          "
          [cmsRouterLink]="product.url"
          [product]="product || {}"
          [productIndex]="index"
          [componentName]="'SearchBox'"
          boelsQa="search-result-suggestion-product"
          [ngClass]="{
            active: index + suggestions().length === activeSearchResultIndex(),
          }"
          boelsDataDm
        >
          <boels-media
            [width]="'50px'"
            [container]="product.images?.[0]"
            [alt]="product.name"
          ></boels-media>
          <div class="name-code">
            <div class="name" [innerHTML]="product.name"></div>
            <boels-product-identifier
              [product]="product"
            ></boels-product-identifier>
          </div>
        </a>
      }
    }
  </div>
} @else if (shouldShowNoResults()) {
  <div class="boels-custom-search-box__results -no-results">
    <p>{{ 'header.searchBox.noMatch' | transloco }}</p>
  </div>
}
